import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "eclipse-timer-container",
  class: "info-overlay-container"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Eclipse Timer", -1)
const _hoisted_3 = {
  key: 0,
  class: "eclipse-countdown"
}
const _hoisted_4 = {
  key: 0,
  class: "ec-timer"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "No eclipse is predicted for this location.", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "mb-4" }
const _hoisted_11 = {
  key: 4,
  class: "eclipse-data-list"
}
const _hoisted_12 = { id: "eclipse-values" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", null, "Totality Duration:", -1)
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", null, "Eclipse Duration:", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("hr", { class: "eclipse-timer-dividier" }, null, -1)
const _hoisted_18 = { id: "time-container" }
const _hoisted_19 = { class: "time" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", { class: "time-label" }, "Partial Start", -1)
const _hoisted_21 = { class: "time-value" }
const _hoisted_22 = {
  key: 0,
  class: "time"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", { class: "time-label" }, "Totality Start", -1)
const _hoisted_24 = { class: "time-value" }
const _hoisted_25 = { class: "time" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", { class: "time-label" }, "Max Eclipse", -1)
const _hoisted_27 = { class: "time-value" }
const _hoisted_28 = {
  key: 1,
  class: "time"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("td", { class: "time-label" }, "Totality End", -1)
const _hoisted_30 = { class: "time-value" }
const _hoisted_31 = { class: "time" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", { class: "time-label" }, "Partial End", -1)
const _hoisted_33 = { class: "time-value" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("hr", {
  class: "mt-4",
  style: {"width":"100%"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_define_term = _resolveComponent("define-term")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.showTimer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (!_ctx.noEclipse)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.timeToShow), 1))
            : _createCommentVNode("", true),
          (!_ctx.noEclipse)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.timeText) + " " + _toDisplayString(_ctx.location !== '' ? 'at ' + _ctx.location : ''), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.noEclipse)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.type) + " Eclipse", 1)
        ])),
    (!_ctx.noEclipse)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass(['eclipse-icon', `eclipse-icon-${_ctx.type.toLowerCase()}`])
        }, null, 2))
      : _createCommentVNode("", true),
    (!_ctx.noEclipse)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("table", _hoisted_12, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createVNode(_component_define_term, {
                  term: "Max Eclipsed",
                  definition: "The fraction (percentage) of the Sun covered by the Moon.",
                  underlined: ""
                }),
                _createTextVNode(": ")
              ]),
              _createElementVNode("td", null, _toDisplayString(_ctx.coverage < 0.01 ? '<1' :(_ctx.coverage*100).toFixed(0)) + "% ", 1)
            ]),
            (_ctx.isTotal)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("td", null, _toDisplayString(_ctx.totalityDuration), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.eclipseDuration != '')
              ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("td", null, _toDisplayString(_ctx.eclipseDuration), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_17,
          _createElementVNode("table", _hoisted_18, [
            _createElementVNode("tr", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.partialStart[1] === '' ? _ctx.timeString(_ctx.partialStart[0]) : 'Sun below Horizon'), 1)
            ]),
            (_ctx.isTotal)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.centralStart[1] === '' ? _ctx.timeString(_ctx.centralStart[0]) : 'Sun below Horizon'), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("tr", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.maxTime[1] === '' ? _ctx.timeString(_ctx.maxTime[0]) : 'Sun below Horizon'), 1)
            ]),
            (_ctx.isTotal)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("td", _hoisted_30, _toDisplayString(_ctx.centralEnd[1] === '' ? _ctx.timeString(_ctx.centralEnd[0]) : 'Sun below Horizon'), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("tr", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("td", _hoisted_33, _toDisplayString(_ctx.partialEnd[1] === '' ? _ctx.timeString(_ctx.partialEnd[0]) : 'Sun below Horizon'), 1)
            ])
          ]),
          _hoisted_34
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_btn_toggle, {
      class: "mt-2",
      modelValue: _ctx.tzPref,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tzPref) = $event)),
      color: _ctx.color,
      divided: "",
      mandatory: "",
      "hide-details": "",
      variant: "outlined"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_btn, {
          value: "UTC",
          size: "small",
          height: "2em"
        }, {
          default: _withCtx(() => [
            _createTextVNode("UTC")
          ]),
          _: 1
        }),
        _createVNode(_component_v_btn, {
          value: "Local",
          size: "small",
          height: "2em"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Local (" + _toDisplayString(_ctx.tzCode) + ")", 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "color"])
  ]))
}